import axios from "../../utils/axios";
import { BASE_API_URL } from "../../config/app";

// 查询模块信息
export function queryModule(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/doc/module",
    method: "get",
    params: params
  });
}

// 查询模块 对应的 参数信息
export function queryRequest(params, data) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/doc/request",
    method: "post",
    params: params,
    data: data
  });
}